import { StrictMode } from "react";
import { createRoot } from 'react-dom/client';
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "./Context/theme";
import { Toaster } from 'react-hot-toast';

// const rootElement = document.getElementById("root");
// ReactDOM.createRoot(
//   <StrictMode>
//     <ThemeProvider>
//       <App />
//     </ThemeProvider>
//   </StrictMode>,
//   rootElement
// );

const root = createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <App />
    <Toaster
      position="bottom-center"
      reverseOrder={false}
      toastOptions={{
        className: '',
        style: {
          fontFamily: "Arial, Helvetica, sans-serif"
        },
      }}
    />
  </ThemeProvider>
  );